import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Button, Dialog } from '../../../../components/ui';
import { useFeatureTheme } from '../../../../theme/hooks/useFeatureTheme';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';

export default function SavedReportsDialog({
  open,
  onClose,
  reports = [],
  pinnedIds,
  onOpen,
  onPin,
}) {
  const { semantic, typography } = useFeatureTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={ANALYTICS_COPY.savedReportsTitle}
      maxWidth="sm"
    >
      {!reports.length ? (
        <Typography sx={{ fontSize: typography.fontSizeMd, color: semantic.text.secondary }}>
          {ANALYTICS_COPY.savedReportsEmpty}
        </Typography>
      ) : (
        <Stack spacing={1}>
          {reports.map((report) => {
            const reportId = report.report_id;
            const pinned = pinnedIds?.has(reportId);
            return (
              <Stack
                key={reportId}
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  py: 1,
                  borderBottom: `1px solid ${semantic.borders.border}`,
                  '&:last-of-type': { borderBottom: 'none' },
                }}
              >
                <Typography
                  sx={{
                    minWidth: 0,
                    fontSize: typography.fontSizeMd,
                    fontWeight: typography.fontWeightMedium,
                    color: semantic.text.primary,
                  }}
                >
                  {report.name}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                  <Button variant="outline" onClick={() => onOpen?.(reportId)}>
                    {ANALYTICS_COPY.openReport}
                  </Button>
                  {pinned ? (
                    <Typography
                      sx={{
                        alignSelf: 'center',
                        fontSize: typography.fontSizeSm,
                        color: semantic.text.secondary,
                      }}
                    >
                      {ANALYTICS_COPY.reportPinned}
                    </Typography>
                  ) : (
                    <Button variant="primary" onClick={() => onPin?.(reportId)}>
                      {ANALYTICS_COPY.pinReport}
                    </Button>
                  )}
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      )}
    </Dialog>
  );
}
